import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=1788688a&"
import script from "./Slider.js?vue&type=script&lang=js&"
export * from "./Slider.js?vue&type=script&lang=js&"
import style0 from "./Slider.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Slider.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Fsoh%2Fcomponents%2Fcontent%2FSlider%2FSlider.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports